import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "pf-cookie-consent";

const CookieConsent = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(KEY)) {
            const t = setTimeout(() => setVisible(true), 1200);
            return () => clearTimeout(t);
        }
    }, []);

    const dismiss = (value) => {
        localStorage.setItem(KEY, value);
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    data-testid="cookie-consent-banner"
                    initial={{ y: 80, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 80, opacity: 0 }}
                    transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
                    className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-3xl border border-white/15 bg-[#0A0A0C]/85 backdrop-blur-2xl"
                >
                    <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:gap-6 md:px-7">
                        <span className="hidden sm:flex h-10 w-10 shrink-0 items-center justify-center border border-gold/30 text-gold">
                            <Cookie size={17} />
                        </span>
                        <p className="flex-1 text-xs leading-relaxed text-zinc-400">
                            We don't set tracking cookies. Embedded TradingView market widgets may set
                            their own cookies to function. See our{" "}
                            <Link
                                to="/legal/privacy-policy"
                                data-testid="cookie-consent-privacy-link"
                                className="text-gold underline-offset-2 hover:underline"
                            >
                                Privacy Policy
                            </Link>
                            .
                        </p>
                        <div className="flex shrink-0 items-center gap-3">
                            <button
                                data-testid="cookie-consent-dismiss"
                                onClick={() => dismiss("dismissed")}
                                className="rounded-full border border-white/15 px-5 py-2 text-xs text-zinc-300 transition-colors duration-300 hover:border-white/40 hover:text-white"
                            >
                                Dismiss
                            </button>
                            <button
                                data-testid="cookie-consent-accept"
                                onClick={() => dismiss("accepted")}
                                className="rounded-full bg-gold px-6 py-2 text-xs font-medium text-black transition-colors duration-300 hover:bg-gold-light"
                            >
                                Got it
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieConsent;
